exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-agree .help-block[data-v-780fe70c]{\n  text-align: center;\n}\n.form-button button:disabled.button-style-7[data-v-780fe70c]{\n  background: #b9b9b9;\n}\n", ""]);

// exports
